@if ((auth$ | async)?.isAuthenticated) {
  <div [ngClass]="{'layout-sidebar-active': (visible$ | async)}" class="layout-wrapper">
    <app-topbar></app-topbar>

    <div class="layout-sidebar">
      <app-menu></app-menu>
    </div>

    <div class="layout-main-container">
      <div class="layout-main">
        <router-outlet></router-outlet>
      </div>
    </div>
    <div class="layout-mask"></div>
  </div>

} @else {
  <div class="login-container">
    <div class="login-card">
      <h2>Generation Y Admin</h2>
      <p>Log in om verder te gaan</p>
      <app-button (onClick)="login()" icon="pi pi-user" label="Login"></app-button>
    </div>
  </div>
}
<p-toast/>
<p-confirmpopup/>
